// Po nasadení zmiznú JS súbory starej verzie. Karta otvorená pred nasadením by
// pri ďalšom kliku nenašla svoj súbor a ukázala 500. Preto sa pri navigácii
// pozrieme, či na serveri nie je novšia verzia, a ak áno, prejdeme na cieľ
// plným načítaním stránky.
const CHECK_EVERY = 30 * 1000

export default defineNuxtPlugin(() => {
	const router = useRouter()
	const config = useRuntimeConfig()
	const currentId = useAppConfig().nuxt?.buildId
	const latestUrl = `${config.app.baseURL.replace(/\/$/, '')}${config.app.buildAssetsDir}builds/latest.json`

	let outdated = false
	let lastCheck = Date.now()
	let pending = null

	const check = () => {
		if (outdated || pending || !currentId) return pending
		lastCheck = Date.now()
		pending = $fetch(`${latestUrl}?${lastCheck}`, { timeout: 1500 })
			.then((meta) => {
				if (meta?.id && meta.id !== currentId) outdated = true
			})
			.catch(() => {})
			.finally(() => {
				pending = null
			})
		return pending
	}

	router.beforeEach(async (to, from) => {
		if (!from.matched.length) return
		if (Date.now() - lastCheck > CHECK_EVERY) await check()
		if (outdated) {
			window.location.assign(router.resolve(to).href)
			return false
		}
	})

	// Po návrate na kartu over verziu hneď, nech je výsledok známy pred klikom.
	document.addEventListener('visibilitychange', () => {
		if (document.visibilityState === 'visible' && Date.now() - lastCheck > CHECK_EVERY) check()
	})
})
